import React from 'react';

export default function Body({ children }) {
    return <div className="body">{children}</div>;
}
